import { Userpilot } from 'userpilot'
import { USER_INFO_KEY } from "../constants/common";
import { get } from "lodash";
import { isImpersonatedToken } from "../helpers/impersonationHelper";


export const initUserPilot = (token) => {
  Userpilot.initialize(token);
};

export const identifyUser = (userId, userData) => {
  Userpilot.identify(userId, userData);
};

// Mirrors services/analytics.js's reset() (PostHog) for the same reason:
// without this, whatever identity Userpilot already holds from a prior
// (typically the admin's own) session in this browser keeps being used
// for flow/survey targeting through an impersonated session - merely
// skipping identify() doesn't clear it.
export const resetUserPilot = () => {
  Userpilot.reset();
};

export const identifyUserByLocalStorage = (userDetailsFromStore) => {
  return new Promise((resolve) => {
    const user = JSON.parse(localStorage.getItem(USER_INFO_KEY) || '{}');
    const userInfo = get(user, 'userInfo');

    // Must never send the impersonated customer's name/email to Userpilot
    // under the admin's browsing session - see the equivalent guard in
    // useAnalyticsIdentify.js's resolveIdentity. Actively resets rather
    // than just skipping identify(), so a residual prior identity in this
    // browser doesn't keep being used for flow targeting.
    if(!userInfo || isImpersonatedToken(get(user, 'token.accessToken'))) {
      resetUserPilot();
      resolve();
      return;
    }

    identifyUser(
      userInfo.userId,
      {
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
        name: [userInfo.firstName, userInfo.lastName].filter(Boolean).join(' '),
        email: user.email || '',
        userType: user.userType || '',
        planName: get(userDetailsFromStore, '0.PlanName'),
        planPeriod: get(userDetailsFromStore, '0.period')
      }
    );
    resolve();
  });
}


export const trackEvent = (eventName, properties) => {
  Userpilot.track(eventName, properties);
};

export const trigger = (token) => {
  Userpilot.trigger(token)
}

export const triggerOnboarding = async () => {
  await identifyUserByLocalStorage();
  trigger(process.env.REACT_APP_USERPILOT_ONBOARDING_FLOW_KEY);
}


export const showUserPilotOnboarding = () => {
  localStorage.setItem("showUserPilotOnboarding","true")
}

export const reloadUserPilot = () => {
  Userpilot.reload()
}

export default Userpilot;
